import React from 'react';
import { Tabs } from '@common/Tabs/Tabs';
import { connectWithStore } from '@react/Common/connectWithStore';
import { updateCurrentTab, getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';
import { PartnerListPage } from './PartnerList';
import { TrackerListPage } from './TrackerList';
import { CustomUserPermissionTabs } from './utils';

interface Props {
  currentTab: string;
  updateCurrentTab: (tabId: string) => void;
}

const CustomUserPermissionsComponent: React.FC<Props> = ({ currentTab, updateCurrentTab }) => (
  <div className="content panel-content flex-one">
    <Tabs
      items={[
        { id: CustomUserPermissionTabs.Tracker, label: t('label.tracker-access') },
        { id: CustomUserPermissionTabs.Partner, label: t('label.partner-access') },
      ]}
      activeTab={currentTab}
      onChange={updateCurrentTab}
    >
      <TrackerListPage id={CustomUserPermissionTabs.Tracker} />
      <PartnerListPage id={CustomUserPermissionTabs.Partner} />
    </Tabs>
  </div>
);

const mapStateToProps = state => {
  const { currentTab } = getUserPermissionsState(state);

  return {
    currentTab,
  };
};

const mapStateToDispatch = {
  updateCurrentTab,
};

export const CustomUserPermissions = connectWithStore(
  mapStateToProps,
  mapStateToDispatch,
)(CustomUserPermissionsComponent);
